import React, { useState, useEffect, useCallback, useRef } from "react";
import Col from 'react-bootstrap/Col';
// import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel, TextField, } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError } from 'yup';
import { Image, Form as RBFORM } from 'react-bootstrap';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    makeStyles,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    IconButton,
    Paper,
    MenuItem,
    Modal,
    Radio,
    RadioGroup,
    FormControlLabel,
} from '@mui/material';
import { Edit, Delete, ContentCopy } from "@mui/icons-material";
import { getMethod, postMethod } from "../../../services/apiService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import OptionIcon from '../../../assets/images/icon/Option.svg';
//import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import * as Yup from "yup";
import { alignPropType } from "react-bootstrap/esm/types";
import CopyIcon from '../../../assets/images/icon/copy.png';
import EditIcon from '../../../assets/images/icon/edit.png';
import DeleteIcon from '../../../assets/images/icon/delete.png';
import { getPartnetId } from "../../../services/authService";
import { clearStorageAndCookies } from "../../../services/authService";
import { useNavigate } from "react-router-dom";
import { AlertDialogs } from "../../dialogs/alertDialogs";
import { ToastContext, useToastContext } from "../../../context/toastContext";
import { usePartnerIdContext } from "../../../context/partnerIdContext";
import CloseIcon from '@mui/icons-material/Close';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {LICENSE_VALIDITY_RANGES} from '../../../constants/constants';
import { PROFILE_TYPE } from "../../../helper/globalConstant";


interface SelectedFeature {
    licenseKey: string;
    quantity: number;
    validity: number;
    activationOn: number;
    expiry: number;
}
function OrderCreateStep2Feature(props: any) {
    const { setToast } = useToastContext() as ToastContext;
    const navigate = useNavigate();
    const saveexitFormBtn = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState(false);
    const [featureModalOpen, setFeatureModalOpen] = useState(false);
    const [validity, setValidity] = useState(30);
    const [editMode, setFeatureEditMode] = useState(false);
    const [editFeatureIndex, setEditFeatureIndex] = useState<number | null>(null);
    const [siteFeatureList, setSiteFeatureList] = useState([]);
    const [featureList, setFeatureList] = useState([]);
    const [filteredFeatureList, setFilteredFeatureList] = useState([]);
    const [selectedFeatureList, setSelectedFeatureList] = useState<SelectedFeature[]>([]);
    const [activationOn, setActivationOn] = useState<number | undefined>(undefined);
    const [expiry, setExpiry] = useState<number | undefined>(undefined);
    const [siteId, setSiteId] = useState<number | undefined>(undefined);
    // const [partnerId, setPartnerId] = useState("");
    const { partnerId, setPartnerId } = usePartnerIdContext();
    const datepickerRef = useRef<HTMLDivElement | null>(null);
    const endDatepickerRef = useRef<HTMLDivElement | null>(null);
    const [maxActivationDays, setMaxActivationDays] = useState(1825);

    const [displayDatePicker, setDisplayDatePicker] = useState(false);
    const [startDate, setStartDate] = useState<any>("");
    const [startMin, setStartMin] = useState<any>("")
    const [startMax, setStartMax] = useState<any>("")


    const [displayEndDatePicker, setDisplayEndDatePicker] = useState<boolean>(false);
    const [endDate, setEndDate] = useState<any>("")
    const [endMin, setEndMin] = useState<any>("")
    const [endMax, setEndMax] = useState<any>("")

    useEffect(() => {
        if(!editMode) { 
            setValidity(30);
            getFilteredFeatureList(30, featureList);
        }
    }, [featureModalOpen]);


    const getDate = (days: number, input?: Date) => {
        const date = input ? new Date(input) : new Date();
        date.setDate(date.getDate() + days);
        return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    };

    const getTimestamp = async (datetime: any) => {
        const date = new Date(datetime);
        const formatted_date = date.toISOString().split("T")[0];
        return new Date(formatted_date).getTime();
    }

    const [initialValues, setInitialValues] = useState({
        // orderRef: props.orderInfo?.orderRef || '',
        // siteId: props.orderInfo?.siteId || siteId,
        // partnerId: props.orderInfo?.partnerId || partnerId,
        licenseKey: props.feature_info?.licenseKey || '',
        validity: props.feature_info?.validity || validity,
        start_date: props.feature_info?.start_date || getDate(0),
        end_date: props.feature_info?.end_date || getDate(1),
        quantity: props.feature_info?.quantity || 1,
    });
    const [availableFeature, setAvailableFeature] = useState(0);



    useEffect(() => {
        fetchFeatureList();
        //setSiteId(props?.siteInfo);
        // setSiteId(43);
    }, []);

    useEffect(() => {
        setStartDate(props.feature_info?.start_date || getDate(0));
        setEndDate(props.feature_info?.end_date || getDate(1));
    }, [props.feature_info?.start_date, props.feature_info?.end_date])

    useEffect(() => {
        console.log(props?.siteInfo)
    }, [props?.siteInfo]);


    useEffect(() => {
        if (siteId) fetchSiteFeatureList();
    }, [siteId]);



    useEffect(() => {
        setInitialValues(prvdata => ({ ...prvdata, partnerId: partnerId || '', siteId: siteId || '', validity: validity || '' }));
    }, [partnerId, siteId, validity]);



    const fetchSiteFeatureList = async () => {
        const resp = await getMethod(`customer/site/enterpriseid/${props.customerInfo?.enterpriseid}`);
        console.log(resp)
        if (resp?.status === 200) {
            setSiteFeatureList(resp?.data?.result);
        } else {
            setToast(resp?.data?.message, "error");
        }
    }




    useEffect(() => {
        if (partnerId) fetchFeatureList();
    }, [partnerId]);


    const fetchFeatureList = async () => {
        // const partner_id = await getPartnetId();
        // setPartnerId(partner_id);
        let partnerInfo
        const sess_user_data = localStorage.getItem("sess_user");
        if (sess_user_data != null) {
            try {
                const sess_user = JSON.parse(sess_user_data);
                const extractedProfileId = sess_user?.userProfile;
                if (extractedProfileId) {
                const priority = extractedProfileId?.priority;
                if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                    partnerInfo = extractedProfileId?.ownerId;
                } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
                    partnerInfo = partnerId
                }
                } else {
                    console.error("Priority id not found in userProfile");
                }
            } catch (error) {
                console.error("Error parsing session user data:", error);
            }
        }
        const resp = await getMethod(`partner/license/${partnerInfo}`);
        console.log(resp)
        if (resp?.status === 200) {
             const feature_list = resp?.data?.result;
            setFeatureList(feature_list);        
            if (feature_list?.length > 0) {
                getFilteredFeatureList(validity, feature_list); 
            } else {
                setFilteredFeatureList(feature_list);
            }
        }
    }



    const getFilteredFeatureList = (validity: number, feature_list: any) => {
        const filteredData = feature_list.filter((item: any) => {
            const { expiryTime, activationTime } = item?.license?.data;
            const msPerDay = 1000 * 60 * 60 * 24;
            const diffInDays = Math.floor(Math.abs(expiryTime - activationTime) / msPerDay);

            const [min, max] = LICENSE_VALIDITY_RANGES[validity] || [];
            return diffInDays >= min && diffInDays <= max;
        });
        setFilteredFeatureList(filteredData);
    }


    //const handleFeatureModalClose = () => setFeatureModalOpen(false);

    const handleCancel = () => {
        if (selectedFeatureList.length == 0) navigate("/customer/overview");
        else {
            setOpen(true);
        }
    }


    const getConfirmResponse = (action: string) => {
        if (action === 'Exit') {
            navigate('/orders');
        } else if (action === 'save&exit') {
            saveexitFormBtn.current?.click();
        }
    }


    const validationSchema = Yup.object({
        // orderRef: Yup.string().trim().optional(),
        // siteId: Yup.number().required("Site id is required!"),
        // partnerId: Yup.string().trim().required("Partner id is required!"),
        licenseKey: Yup.string().required("Feature is required!"),
        validity: Yup.string().required("Validity is required!"),
        start_date: Yup.date().required("Start Date is required!"),
        end_date: Yup.date().required("End Date is required!"),
        quantity: Yup.number().min(1, "Quantity must be at least 1.").required("Quantity is required!"),
    });


    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    const handleValidityChange = (value: number, start_date: Date, setFieldValue: any) => {
        setValidity(value);
        setFieldValue("validity", value);
        setFieldValue("licenseKey", '');
        // handleStartDateChange(value, start_date, setFieldValue);
        getFilteredFeatureList(value, featureList);
    }


    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    const handleStartDateChange = (
      raw_validity: number,
      start_date: any,
      setFieldValue: any,
    ) => {
      if (start_date) {
        if (typeof start_date !== "string") {
          start_date = start_date.toISOString().split("T")[0];
        }

        setFieldValue("start_date", start_date);
        setStartDate(startDate);
        setEndMin(getDate(1, start_date));
        setDisplayDatePicker(false);
      } else {
        setFieldValue("start_date", "");
        setFieldValue("end_date", "");
      }
    };

  const handleEndDateChange = (raw_validity: number, end_date: any, setFieldValue: any) => {
    if (end_date) {
      if (typeof end_date !== "string") {
        end_date = end_date.toISOString().split("T")[0];
      }
      setFieldValue("end_date", end_date);
      setEndDate(end_date);
      setStartMax(getDate(-1, end_date))
      setDisplayDatePicker(false);
    } else {
      setFieldValue("start_date", "");
      setFieldValue("end_date", "");
    }
  };
    


    const deleteFeatureFromSelectedList = (index: number) => {
        setSelectedFeatureList((prevItems) => {
            const newList = prevItems.filter((_, i) => i !== index);
            props.setSelectedFeatureList(newList);
            return newList;
        });
    }

    const handleOpenFeaturePopup = (action: string, row: any, index: number) => {
        if (action === "edit") {
            let start_date: Date | string = new Date(row.activationOn);
            let end_date: Date | string = new Date(row.expiry);
            // Format the date (e.g., "YYYY-MM-DD")
            start_date = start_date.toISOString().split("T")[0];
            end_date = end_date.toISOString().split("T")[0];
            setInitialValues({
                licenseKey: row.licenseKey,
                quantity: row.quantity,
                validity: row.validity,
                end_date: end_date,
                start_date: start_date,
            });
            setValidity(row.validity);
            getAvailableFeatureCount(row.licenseKey);
            getFilteredFeatureList(row.validity, featureList);
            setEditFeatureIndex(index)
            setFeatureEditMode(true);
        } else {
            setFeatureEditMode(false);
        }
        setFeatureModalOpen(true);
    }


    const duplicateFeature = (index: number) => {
        const selectedFeature = selectedFeatureList[index];
        setSelectedFeatureList((prevList) => {
            const newList = [...prevList, selectedFeature];
            props.setSelectedFeatureList(newList);
            return newList;
        });
    }



    const getAvailableFeatureCount = (licenseKey: string) => {
        const feature: any = featureList.find((item: any) => item?.license?.key === licenseKey);
        if (feature) {
            const msPerDay = 1000 * 60 * 60 * 24;
            const diffInDays = Math.floor(Math.abs(feature?.license?.data?.expiryTime - feature?.license?.data?.activationTime) / msPerDay);
            setMaxActivationDays(diffInDays);

            const available = feature?.countData?.available;
            setAvailableFeature(available);
        }
    }

    const handleFeatureChange = (licenseKey: string, values: any,setFieldValue: any) => {
        if (licenseKey != "") {
        const feature: any = featureList.find((item: any) => item?.license?.key === licenseKey);
        if (feature) {
            const expiry = feature?.license?.data?.expiryTime;
            const expiryDate = new Date(expiry)
            setStartMin(getDate(0))
            setStartMax(getDate(-1, expiryDate))
            setEndMin(getDate(1))
            setEndMax(formatDate(expiryDate))
            setStartDate(getDate(0))
            setEndDate(formatDate(expiryDate))
            setFieldValue('start_date', getDate(0))
            setFieldValue('end_date', formatDate(expiryDate))
            const available = feature?.countData?.available;
            setAvailableFeature(available);
        }
        } else {
            setAvailableFeature(0);
        }
        setFieldValue("licenseKey", licenseKey);
        setFieldValue("quantity", 1)
    }


    const submitForm = async (submitBtnType: string) => {
        if (selectedFeatureList.length > 0) {
            let partnerInfo
            const sess_user_data = localStorage.getItem("sess_user");
            if (sess_user_data != null) {
                try {
                    const sess_user = JSON.parse(sess_user_data);
                    const extractedProfileId = sess_user?.userProfile;
                    if (extractedProfileId) {
                    const priority = extractedProfileId?.priority;
                    if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                        partnerInfo = extractedProfileId?.ownerId;
                    } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
                        partnerInfo = props?.orderInfo?.partnerId
                    }
                    } else {
                        console.error("Priority id not found in userProfile");
                    }
                } catch (error) {
                    console.error("Error parsing session user data:", error);
                }
            }
        
            const payload = {
                orderName: props?.orderInfo?.orderName,
                orderRef: props?.orderInfo?.orderRef,  // need to fetch from page one
                siteId: props?.orderInfo?.siteId,  // need to fetc from page one
                partnerId: partnerInfo,
                data: selectedFeatureList,
            }

            console.log("//////////////////////", payload)
            const resp = await postMethod("customer/order", payload);
            if (resp?.status === 200) {
                setToast(resp?.data?.message, "success");


                if (submitBtnType === "next") {
                    props.setActiveStep(2);
                    props.setOrderInfo(resp?.data?.result?.[0]);
                    props.setSelectedFeatureList(selectedFeatureList);
                } else if (submitBtnType === "save&exit") {
                    navigate("/orders");
                }
            } else {
                setToast(resp?.data?.message, "error");
            }
        }
    }



    useEffect(() => {
        setSelectedFeatureList(props.selectedFeatureList);
    }, [props.selectedFeatureList])


    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (datepickerRef.current && !datepickerRef.current.contains(event.target as Node)) {
                setDisplayDatePicker(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    
    useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
        if (
          endDatepickerRef.current &&
          !endDatepickerRef.current.contains(event.target as Node)
        ) {
          setDisplayEndDatePicker(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    return (
        <>
            <Box>
                <div style={{ padding: "20px", color: "#fff" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "40px" }}>
                        {/* <span style={{ marginRight: "8px", color: '#E2E3E3', fontSize: '14px' }}>Created order for product bundle</span>
                        <Switch /> */}

                        {selectedFeatureList.length > 0 &&
                            <Button onClick={() => handleOpenFeaturePopup('new', null, 0)} variant="contained" sx={{ color: '#1F2F34', height: '41px', lineHeight: '41px', borderColor: '#17B2EB', background: '#17B2EB', borderRadius: '30px', fontSize: '14px', fontWidth: '500', textTransform: 'unset', position: "absolute", right: "45px" }}>
                                Add Feature
                            </Button>
                        }
                    </div>


                    <Box sx={{ backgroundColor: "#03171F", borderRadius: 2, border: "1px solid #313838" }}>
                        {/* Header Row */}
                        <Paper
                            elevation={1}
                            sx={{
                                backgroundColor: "#03171F",
                                p: 2,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #313838",
                            }}
                        >
                            <Grid container spacing={2} style={{ width: '100%', }}>
                                <Grid size={{ xs: 1 }}>
                                    <Typography sx={{ color: "#E2E3E3", fontSize: "16px" }}>No.</Typography>
                                </Grid>
                                <Grid size={{ xs: 3 }}>
                                    <Typography sx={{ color: "#E2E3E3", fontSize: "16px" }}>Feature</Typography>
                                </Grid>
                                <Grid size={{ xs: 3 }}>
                                    <Typography sx={{ color: "#E2E3E3", fontSize: "16px" }}>License Type</Typography>
                                </Grid>
                                <Grid size={{ xs: 2 }}>
                                    <Typography sx={{ color: "#E2E3E3", fontSize: "16px" }}>Quantity</Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    <Typography sx={{ color: "#E2E3E3", fontSize: "16px" }}></Typography>
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* Data Rows */}
                        {selectedFeatureList.map((row: any, index: number) => (
                            <Paper
                                key={index}
                                elevation={1}
                                sx={{
                                    backgroundColor: "#03171F",
                                    p: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "1px solid #313838"
                                }}
                            >
                                <Grid container spacing={2} style={{ width: '100%' }}>
                                    <Grid size={{ xs: 1 }}>
                                        <Typography sx={{ color: "#E2E3E3", fontSize: "14px" }}>{index + 1}</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 3 }}>
                                        <Typography sx={{ color: "#E2E3E3", fontSize: "14px" }}>
                                            {featureList?.map((feature: any) => {
                                                if (feature.license.key === row.licenseKey) {
                                                    return feature?.license?.data?.name;
                                                } else {
                                                    return "";
                                                }
                                            })}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 3 }}>
                                        <Typography sx={{ color: "#E2E3E3", fontSize: "14px" }}>
                                            {(row?.validity === 1 || row?.validity === 3 || row?.validity === 5) ? `${row?.validity} Year${row?.validity > 1 ? 's' : ''}` : (
                                                row?.validity === 30 ? "30 Days" : (
                                                    row?.validity === 365 ? "1 Year" : (
                                                        row?.validity / 365 + " Years")
                                                    )
                                                )                                               
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 2 }}>
                                        <Typography sx={{ color: "#E2E3E3", fontSize: "14px" }}>{row.quantity}</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 1 }}>
                                        <Box display="flex" justifyContent="flex-end">
                                            <Image src={CopyIcon} style={{ fontSize: '20px', padding: '0px 12px', cursor: 'pointer' }} onClick={() => duplicateFeature(index)}></Image>
                                            <Image src={EditIcon} style={{ fontSize: '20px', padding: '0px 12px', cursor: 'pointer' }} onClick={() => handleOpenFeaturePopup('edit', row, index)}></Image>
                                            <Image src={DeleteIcon} style={{ fontSize: '20px', padding: '0px 12px', cursor: 'pointer' }} onClick={() => deleteFeatureFromSelectedList(index)}></Image>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        ))}
                    </Box>
                </div>

                {selectedFeatureList.length == 0 &&
                    <Box sx={{ textAlign: "center" }}>
                        <img src={OptionIcon} alt="" width={120} height={134} />
                        <span className="noT">No feature added</span>
                        <Button onClick={() => handleOpenFeaturePopup('new', null, 0)} variant="contained" sx={{ color: '#1F2F34', height: '41px', lineHeight: '41px', borderColor: '#17b2eb', background: '#17b2eb', borderRadius: '30px', fontSize: '14px', fontWidth: '500', textTransform: 'none' }}>
                            Add Feature
                        </Button>
                    </Box>
                }
            </Box>


            <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                sx={{
                    backgroundColor: '#03171F',
                    boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                }}>
                <Button onClick={() => { props.setSelectedFeatureList(selectedFeatureList); props.setActiveStep(0); }} variant="outlined" sx={{ color: '#0699CE', height: '41px', lineHeight: '41px', border: '0', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                    Previous
                </Button>
                <Button onClick={() => setOpen(true)} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                    Cancel
                </Button>
                <Button type="button" onClick={() => submitForm("save&exit")} ref={saveexitFormBtn} variant="outlined"
                    sx={{
                        color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', cursor: selectedFeatureList.length > 0 ? 'pointer' : 'default',
                        '&:disabled': {
                            background: '#ccc !important',
                            cursor: 'not-allowed',
                        }
                    }}
                    className={selectedFeatureList.length > 0 ? "" : "btnDisable"}
                >
                    Save & Exit
                </Button>

                <Button
                    type="button"
                    onClick={() => submitForm("next")}
                    variant="contained"
                    color="primary"
                    // className={selectedFeatureList.length > 0 ? "btnBlue" : "btnDisable"}
                    className={selectedFeatureList.length > 0 ? "btnBlue" : "btnDisable"}

                    sx={{
                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                        borderColor: '#0B4A62',
                        borderRadius: '25px', fontSize: '14px', fontWidth: '500',
                        cursor: selectedFeatureList.length > 0 ? 'pointer' : 'default',
                        // '&:disabled': {
                        //     background: '#ccc',
                        //     cursor: 'not-allowed',
                        // },
                    }}
                >
                    Next
                </Button>
            </Stack>


            <Modal open={featureModalOpen} onClose={() => setFeatureModalOpen(false)} className="AddFeatureM">
                <Box sx={{
                    maxWidth: '736px',
                    width: '100%',
                    margin: '64px auto 0',
                    padding: '24px',
                    borderRadius: '30px',
                    borderColor: '#5A5F60 !important',
                    border: '1px solid',

                }}
                >
                    <Typography variant="h6" component="h2" gutterBottom
                        sx={{
                            fontSize: '20px',
                            color: '#E2E3E3',
                            borderBottom: '1px solid #5A5F60',
                            paddingBottom: '10px',
                            marginBottom: '30px',
                        }}
                    >
                        {editMode ? "Edit Feature" : "Add a Feature"}
                        <CloseIcon style={{ float: "right", cursor: "pointer" }} onClick={() => setFeatureModalOpen(false)} />
                    </Typography>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            console.log("Form Submitted:", values);

                            const feature: any = featureList.find((item: any) => item?.license?.key === values.licenseKey);
                            const productId = feature?.license?.data?.productId;
                            const analyticType = feature?.license?.data?.analyticType;

                            const payload = {
                                licenseKey: values.licenseKey,
                                quantity: parseInt(values.quantity),
                                validity: values.validity,
                                activationOn: await getTimestamp(values.start_date),
                                expiry: await getTimestamp(values.end_date),
                                featureName: feature.license?.data?.name,
                                licenseType: feature?.license?.data?.licenseType,
                            } as Record<string, any>                            

                            if (productId) {
                                payload.productId = productId;
                            }
                            if (analyticType !== 0) {
                                payload.analyticType = analyticType;
                            }

                            if (editMode && editFeatureIndex !== null && editFeatureIndex >= 0) {
                                setSelectedFeatureList((prevList: any) =>
                                    prevList.map((item: any, idx: number) =>
                                        idx === editFeatureIndex ? { ...item, ...payload } : item
                                    )
                                );
                                props.setSelectedFeatureList((prevList: any) =>
                                    prevList.map((item: any, idx: number) =>
                                        idx === editFeatureIndex ? { ...item, ...payload } : item
                                    )
                                );
                                setToast("Feature changes saved successfully!", "success");
                            } else {
                                setSelectedFeatureList((prevList: any) => [...prevList, payload]);
                                props.setSelectedFeatureList((prevList: any) => [...prevList, payload]);
                            }

                            setFeatureModalOpen(false);
                        }}
                    >
                        {({ values, isSubmitting, setFieldValue }) => (
                            <Form>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Box sx={{ mb: 2 }}>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    color: '#B4B7B8',
                                                    fontSize: '16px',
                                                    marginBottom: '10px',
                                                }}
                                            >
                                                Feature Information
                                            </Typography>

                                            <RBFORM.Group>
                                                <Typography variant="subtitle1"
                                                    sx={{
                                                        color: '#B4B7B8',
                                                        fontSize: '16px',
                                                        marginBottom: '2px',
                                                    }}
                                                >
                                                    Feature
                                                </Typography>
                                                <Field
                                                    name="licenseKey"
                                                    as="select"
                                                    className="inputC custDropdown"
                                                    onChange={(e: any) => handleFeatureChange(e.target.value, values, setFieldValue)}
                                                >
                                                    <option value=''>Select Feature</option>
                                                    {filteredFeatureList.length > 0 &&
                                                        filteredFeatureList.map((feature: any, index: number) => (
                                                            <option key={feature?.license?.key} value={feature?.license?.key}>{feature?.license?.data?.name}</option>
                                                        ))
                                                    }
                                                </Field>
                                                <ErrorMessage name="licenseKey">
                                                    {(msg) => <Typography sx={{ color: "#f44336", fontSize: "11px", marginTop: "-15px" }}>{msg}</Typography>}
                                                </ErrorMessage>
                                            </RBFORM.Group>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography variant="h6"
                                            sx={{
                                                fontSize: '16px',
                                                color: '#B4B7B8',
                                                fontWeight: '400',
                                            }}
                                        >
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    color: '#B4B7B8',
                                                    fontSize: '16px',
                                                    marginBottom: '10px',
                                                }}
                                            > License Type</Typography>
                                        </Typography>
                                        <Box sx={{ mb: 2 }}>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    color: '#B4B7B8',
                                                    fontSize: '14px',
                                                    marginBottom: '5px',
                                                }}
                                            > Valid from Activation
                                            </Typography>
                                            <RadioGroup
                                                name="validity"
                                                row
                                                value={validity}
                                                onChange={(e) => handleValidityChange(parseInt(e.target.value), values.start_date, setFieldValue)}
                                                style={{ borderRadius: "30px", backgroundColor: "#293236" }}
                                            >
                                                <FormControlLabel value={30} control={<Radio />} label="30 Days" />
                                                <FormControlLabel value={365} control={<Radio />} label="1 Year" />
                                                <FormControlLabel value={1095} control={<Radio />} label="3 Years" />
                                                <FormControlLabel value={1825} control={<Radio />} label="5 Years" />
                                            </RadioGroup>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        marginBottom: '10px',
                                    }}

                                >
                                    <Typography variant="subtitle1"
                                        sx={{
                                            color: '#B4B7B8',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                        }}
                                        className="tagR"
                                    >License Usage</Typography>

                                </Box>

                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <RBFORM.Group>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    color: '#B4B7B8',
                                                    fontSize: '16px',
                                                    marginBottom: '2px',
                                                }}
                                            > Starts</Typography>
                                            <Field
                                                name="start_date"
                                                as="input"
                                                type="date"
                                                component={TextField}
                                                className="inputC inputCalendar"
                                                InputProps={{
                                                    inputProps: {
                                                        min: getTodayDate(), // Set today's date as the minimum date
                                                        readOnly: true,
                                                    },
                                                }}
                                                onClick={(e: any)=>{setStartDate(values.start_date); setDisplayDatePicker(true);}}
                                            />

                                            {displayDatePicker &&
                                                <div ref={datepickerRef} style={{ position: "absolute", marginTop: "-60px", marginLeft: "90px", zIndex: 9999 }}>
                                                    <DatePicker
                                                        selected={startDate}
                                                        onChange={(date) => handleStartDateChange(validity, date, setFieldValue)}
                                                        minDate={startMin}
                                                        maxDate={startMax}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        inline
                                                        id="custom-date-picker"
                                                    />
                                                </div>
                                            }

                                        </RBFORM.Group>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <RBFORM.Group>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    color: '#B4B7B8',
                                                    fontSize: '16px',
                                                    marginBottom: '2px',
                                                }}
                                            > Ends</Typography>
                                            <Field
                                                name="end_date"
                                                type="date"
                                                component={TextField}
                                                className="inputC inputCalendar"
                                                InputProps={{
                                                    inputProps: {
                                                        min: getTodayDate(),
                                                        readOnly: true,
                                                    },
                                                }}
                                                onClick={(e: any)=>{setEndDate(values.end_date); setDisplayEndDatePicker(true);}}
                                            />
                    
                                            {displayEndDatePicker &&
                                                <div ref={endDatepickerRef} style={{ position: "absolute", marginTop: "-60px", marginLeft:"90px", zIndex: 9999 }}>
                                                    <DatePicker
                                                        selected={endDate}
                                                        onChange={(date) => handleEndDateChange(validity, date, setFieldValue)}
                                                        minDate={endMin}
                                                        maxDate={endMax}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        inline
                                                        id="custom-end-date-picker"
                                                    />
                                                </div>
                                            }
                                        </RBFORM.Group>
                                    </Grid>
                                </Grid>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <Typography variant="subtitle1"
                                        sx={{
                                            color: '#B4B7B8',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                        }}
                                        className="tagR"
                                    >License Options</Typography>
                                </Box>

                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <RBFORM.Group>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    color: '#B4B7B8',
                                                    fontSize: '16px',
                                                    marginBottom: '2px',
                                                }}
                                            >   Quantity {availableFeature > 0 &&
                                                <span style={{ float: "right", fontSize: "12px", marginTop: "5px", marginRight: "10px" }}>
                                                    <img src={"/info.png"} style={{ display: "block", float: "left", marginTop: "2px" }}></img>&nbsp;
                                                    Available - {availableFeature}
                                                </span>}
                                            </Typography>
                                            <button
                                                disabled={values.licenseKey ? false : true}
                                                type="button"
                                                onClick={(e: any) => {
                                                    // Ensure invalid values like -5 are reset
                                                    const value = parseInt(values.quantity, 10);
                                                    if (value >= 1 && value <= availableFeature) {
                                                        setFieldValue('quantity', Math.max(values.quantity - 1, 1));
                                                    } else if (value < 1) {
                                                        setFieldValue('quantity', 1); // Reset to minimum
                                                    } else if (value > availableFeature) {
                                                        setFieldValue('quantity', availableFeature); // Reset to maximum
                                                    }
                                                }}
                                                style={{
                                                    background: 'transparent',
                                                    color: '#E2E3E3',
                                                    cursor: 'pointer',
                                                    outline: 'none',
                                                    border: '1px solid #313838',
                                                    padding: '0px 15px',
                                                    height: '40px',
                                                    borderRadius: '5px 0px 0px 5px',
                                                }}
                                                className="incr-dcr-btn"
                                            >
                                                -
                                            </button>
                                            <Field
                                                name="quantity"
                                                type="number"
                                                style={{
                                                    width: "75%",
                                                    height: "40px",
                                                    textAlign: "center",
                                                    borderRadius: '0px',
                                                }}
                                                className="inputC"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    // Ensure invalid values like -5 are reset
                                                    const value = parseInt(e.target.value, 10);
                                                    if (value >= 1 && value <= availableFeature) {
                                                        setFieldValue('quantity', value);
                                                    } else if (value < 1) {
                                                        setFieldValue('quantity', 1); // Reset to minimum
                                                    } else if (value > availableFeature) {
                                                        setFieldValue('quantity', availableFeature); // Reset to maximum
                                                    }
                                                }}
                                            />
                                            <button
                                                disabled={values.licenseKey ? false : true}
                                                type="button"
                                                onClick={(e: any) => {
                                                    // Ensure invalid values like -5 are reset
                                                    const value = parseInt(values.quantity, 10);
                                                    if (value >= 1 && value <= availableFeature) {
                                                        setFieldValue('quantity', Math.min(values.quantity + 1, availableFeature));
                                                    } else if (value < 1) {
                                                        setFieldValue('quantity', 1); // Reset to minimum
                                                    } else if (value > availableFeature) {
                                                        setFieldValue('quantity', availableFeature); // Reset to maximum
                                                    }
                                                }}
                                                style={{
                                                    background: 'transparent',
                                                    color: '#E2E3E3',
                                                    cursor: 'pointer',
                                                    outline: 'none',
                                                    border: '1px solid #313838',
                                                    padding: '0px 15px',
                                                    height: '40px',
                                                    borderRadius: '0px 5px 5px 0px',
                                                }}
                                                className="incr-dcr-btn"
                                            >
                                                +
                                            </button>
                                        </RBFORM.Group>
                                    </Grid>

                                    <Field
                                        name="siteId"
                                        type="hidden"
                                        component={TextField}
                                        className="inputC"
                                        value={siteId}
                                        style={{ display: "none" }}
                                    />

                                    <Field
                                        name="partnerId"
                                        type="hidden"
                                        component={TextField}
                                        className="inputC"
                                        value={partnerId}
                                        style={{ display: "none" }}
                                    />
                                </Grid>

                                {/* {JSON.stringify(values, null, 2)} */}



                                <Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
                                    <Button onClick={() => setFeatureModalOpen(false)} variant="outlined"
                                        sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={isSubmitting}
                                        sx={{
                                            color: '#1F2F34', height: '41px', lineHeight: '41px',
                                            borderColor: '#0B4A62', background: '#17B2EB',
                                            borderRadius: '25px', fontSize: '14px',
                                            fontWidth: '500',
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        {editMode ? "Save Changes" : "Confirm"}
                                    </Button>
                                </Box>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal>


            <AlertDialogs
                open={open}
                setOpen={setOpen}
                getConfirmResponse={getConfirmResponse}
                title="Cancel Order Creation"
                message="Are you sure want to cancel creating the order?<br/>Any information entered will not be saved.<br/><br/>Click 'Exit' to confirm cancellation."
                button1="Continue Editing"
                button2="Exit"
            />
        </>
    )
}

export default OrderCreateStep2Feature